import React from 'react';
import { Container, Row, Col } from 'reactstrap';

export default function SellerReportMessage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <p>This is a Seller specific report. Please select a new report or select a Seller account.</p>
        </Col>
      </Row>
    </Container>
  );
}
